import store from '@/store/store'
// import Cookies from 'js-cookie';
import { getQueryString } from "@/utils/location"
import { judgeDeviceType } from "@/utils/device"
import { getDevicePlatform, getDevicePlatformDetail } from '@/utils/collect'

import Vue from 'vue';
window.EventBus = new Vue();
export default {
  name: 'App',
  store,
  data() {
    return {
      active: '',
      icon: {
      },
      initWinHeight:0,
      hashMap: {},
      isRouterAlive: true
    }
  },
  created() {
    this.hashMap = {};
    let dom = document.querySelector('#app-loading')
    if(dom){
      dom.style.display = 'none'
    }
    window.platformSource = this.$getUrlKeyWord('source')||this.$getUrlKeyWord('platform');//来源
    let ww_token =this.$getUrlKeyWord('ww_token')
    ww_token&&localStorage.setItem('ww_token',ww_token)
  },
  mounted(){
    const wwid = getQueryString('wwid')
    if (wwid) {
      setCollectUserID(wwid);
    }
    window.collectEvent('config', {
      ww_device_platform: getDevicePlatform(),
      ww_device_platform_detail: getDevicePlatformDetail(),
      wwid: localStorage.getItem("wwid") || '-1',
    })
    // if(window.platformSource == 'tt'){
    if(window.platformSource != 'app'){//app的高度获取依然保留原逻辑
      this.initKeyBoardHeight()//小程序不传入h的时候键盘高度在h5页面获取 
    }
    window.appSendFlutterVersion = this.appSendFlutterVersion
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => (this.isRouterAlive = true));
    },
    updateContainerHeight(keyboardHeight) {
      const trigger = this.$store.state.keyboardTrigger // 此处只关注editor页面的键盘事件，后续考虑把containerHeight合并到editor页面中
      if (trigger === 'editor') {
        setTimeout(() => {
          const container = document.querySelector('.real-container')
          container.style.height = judgeDeviceType.isIOS ? `calc(100vh - ${keyboardHeight}px)` : '100vh'
        }, 100)
      }
    } ,
    initKeyBoardHeight(){
      let href=location.href;
      let visualViewport = window.visualViewport
      if (judgeDeviceType.isIOS && visualViewport&&href.indexOf('h=')==-1) {
        this.initWinHeight = visualViewport.height;
        console.log('initWinHeight',this.initWinHeight);
        visualViewport.addEventListener("resize", this.onIosKeyboardChange);
      }
    },
    onIosKeyboardChange() {
      // if (speakerListRef) {
        let visualViewport = window.visualViewport
        console.log("====>>>>ios", visualViewport.height, this.initWinHeight);
        // setTimeout(()=>{
          const keyboardHeight = this.initWinHeight - visualViewport.height; // 键盘高度
          console.log('keybordHeight',keyboardHeight);
          if (keyboardHeight > 180) {
            this.$store.state.cachedKeyboardHeight = keyboardHeight;
            this.updateContainerHeight(keyboardHeight)
          }else{
            this.updateContainerHeight(keyboardHeight)
          }
        // },200)
      
      // }
    },
    appSendFlutterVersion(version) {
      this.$store.state.appVersion = version
    }
  },
  watch: {
    $route() {
      // 小程序的键盘逻辑
      if(this.$route.query.h){
        console.log('路由发生改变',this.$route);
        const keyboardHeight = parseInt(this.$route.query.h || 0)
        if (parseInt(this.$route.query.h)) {
          if (parseInt(this.$route.query.h) > 180) {
            this.$store.state.cachedKeyboardHeight = parseInt(this.$route.query.h);
          }
          this.updateContainerHeight(keyboardHeight)
        } else {
          this.updateContainerHeight(keyboardHeight)
        }
      }
    
      // if(this.$route.query.r) {
      //   this.reload();
      //   return
      // }

      let key = this.$route.query.k;
      if(key){
      if(this.hashMap[key]) {
        console.log('naviBack');
        this.hashMap = {};
        window.taroRawSdk.miniProgram.navigateBack();
      } else {
        this.$set(this.hashMap, key, this.$route.fullPath);
      }
      console.log(this.$route)
    }
    }
  },
  beforeCreate() {

  }
}
